import { handleActions } from 'redux-actions';
import { saveState } from '../utils/localStorage';
import { postData, deleteData } from '../utils/request';
import { loadData, loadUser } from './data';
import { retrieveProfile } from './profile';

const initialState = {
  email: null,
  token: null,
  error: null,
  message: null,
  profileImage: null,
  firstName: null,
  lastName: null,
  loggedIn: false,
  status: '',
  operatingCity: '',
  existingUberPartner: null,
  depositPaid: null,
  certification: ''
};

const LOGIN_ATTEMPT = 'LOGIN_ATTEMPT';
const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
const LOGIN_FAILURE = 'LOGIN_FAILURE';
const LOGOUT = 'LOGOUT';
const UPDATE_USER_STATUS = 'UPDATE_USER_STATUS';
const USER_RETRIEVED = 'USER_RETRIEVED';

/** ******************* ACTIONS ******************** */

const loginAttempt = () => ({
  type: [LOGIN_ATTEMPT]
});

export const loginSuccess = ({
  email,
  authentication_token,
  first_name,
  last_name,
  uber_profile_image,
  status,
  operating_city,
  existing_uber_partner,
  deposit_paid,
  uberx_status,
  via_consent,
  tlc_number,
  employment_eligibility_image,
  total_cumulative_balance
}) => ({
  type: [LOGIN_SUCCESS],
  email,
  authentication_token,
  uber_profile_image,
  first_name,
  last_name,
  operating_city,
  existing_uber_partner,
  status,
  deposit_paid,
  uberx_status,
  via_consent,
  tlc_number,
  employment_eligibility_image,
  total_cumulative_balance
});

export const loginFailure = error => ({
  type: [LOGIN_FAILURE],
  error
});

const logoutSuccess = history => {
  if (history !== 'none') {
    window.location.assign(history);
  }
  return { type: [LOGOUT] };
};

export const tryLogin = (body, history) => dispatch => {
  dispatch(loginAttempt());
  return postData('sessions', body)
    .then(response => {
      saveState({
        auth: {
          email: response.email,
          token: response.authentication_token
        }
      });
      dispatch(loginSuccess(response, dispatch));
    })
    .then(() => retrieveProfile())
    .then(() => loadUser())
    .then(() => setTimeout(() => dispatch(loadData()), 1000))
    .then(() => history.push('/dashboard'))
    .catch(() => dispatch(loginFailure('Invalid email or password')));
};

export const logout = history => dispatch =>
  deleteData('sessions').then(() => {
    localStorage.clear();
    return dispatch(logoutSuccess(history));
  });
// .then(() => window.location.reload());

export const updateUserStatus = status => ({
  type: [UPDATE_USER_STATUS],
  status
});

export const userRetrieved = response => ({
  type: [USER_RETRIEVED],
  response
});

/** ******************* REDUCER ******************** */

export default handleActions(
  {
    [LOGIN_ATTEMPT]: state => ({
      ...state,
      error: null,
      message: null
    }),

    [LOGIN_SUCCESS]: (
      state,
      {
        email,
        authentication_token,
        first_name,
        last_name,
        uber_profile_image,
        operating_city,
        existing_uber_partner,
        status,
        deposit_paid,
        uberx_status,
        via_consent,
        tlc_number,
        employment_eligibility_image,
        total_cumulative_balance
      }
    ) => ({
      ...state,
      token: authentication_token,
      email,
      profileImage: uber_profile_image,
      firstName: first_name,
      lastName: last_name,
      operatingCity: operating_city,
      existingUberPartner: existing_uber_partner,
      loggedIn: true,
      error: null,
      status,
      depositPaid: deposit_paid,
      uberXStatus: uberx_status,
      viaConsent: via_consent,
      tlcNumber: tlc_number,
      employmentEligibilityImage: employment_eligibility_image,
      totalCumulativeBalance: total_cumulative_balance
    }),

    [LOGOUT]: state => ({
      // ...state,
      // email: null,
      // token: null,
      // loggedIn: false,
      // error: null,
      // uberx_status: null,
      initialState
    }),

    [LOGIN_FAILURE]: (state, { error }) => ({
      ...state,
      error
    }),

    [UPDATE_USER_STATUS]: (state, { status }) => ({
      ...state,
      status
    }),

    [USER_RETRIEVED]: (state, { response }) => ({
      ...state,
      ...response
    })
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/redux/auth.js